import React from 'react';
import importIcon from '../../asset/icon/import.png';
import HintWrapper from '../../shared/component/headless/button/HintWrapper';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import { getHintMessage } from '../../shared/constants/hintMessages';
import { MemberType, ModalType } from '../../shared/enum/EnumRepository';
import { useSettingStore } from '../../shared/store/settingStore';
import { useModalStore } from '../../shared/store/portal/modalStore';

const TextImportButton: React.FC = () => {
  const memberType = useSettingStore((state) => state.setting?.memberType);
  const setStandardModal = useModalStore((state) => state.setStandardModal);

  if (memberType !== MemberType.GROUP) return null;

  const handleClick = () => {
    setStandardModal({
      modalType: ModalType.TEXT_COPY_IMPORT,
      title: null,
      value: null,
      handleChange: () => {},
    });
  };

  return (
    <HintWrapper content={getHintMessage('IMPORT_LINKED_TEXTS')}>
      <UniversalIconBtn
        size="standard"
        border
        backgroundImg={importIcon}
        onClick={handleClick}
        aria-label={getHintMessage('IMPORT_LINKED_TEXTS')}
      />
    </HintWrapper>
  );
};

export default TextImportButton;
